<template>
  <g transform="translate(6)">
    <path
      d="M0,0H24V24H0Z"
      transform="translate(-6 0)"
      fill="none"
      opacity="0.87"
    />
    <g transform="translate(-3 2)">
      <path
        d="M11.809,6.01a6.739,6.739,0,1,0,6.739,6.739A6.734,6.734,0,0,0,11.809,6.01Zm.963,7.7H10.846V7.935h1.925Z"
        transform="translate(-3.145 -1.196)"
        fill="#b5dce0"
        opacity="0.758"
      />
      <path
        d="M8.846,1.01h5.776V2.935H8.846Zm1.925,6.739H12.7v5.776H10.772Zm7.731-.6L19.87,5.785a10.636,10.636,0,0,0-1.357-1.357L17.145,5.795A8.664,8.664,0,1,0,18.5,7.152ZM11.735,19.3a6.739,6.739,0,1,1,6.739-6.739A6.734,6.734,0,0,1,11.735,19.3Z"
        transform="translate(-3.07 -1.01)"
        fill="#1b8089"
      />
    </g>
  </g>
</template>
